import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { manageServiceWorker } from "./app/install";
import "./styles.css";

const container = document.getElementById("root");
if (container === null) throw new Error("Missing #root element in index.html.");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Imported before render so the module-level `beforeinstallprompt` listener in
// install.ts is in place when Chromium fires it — which is often before React
// has mounted, and only ever once.
manageServiceWorker(import.meta.env.PROD);
